import * as Headless from '@headlessui/react'
import clsx from 'clsx'
import React, { forwardRef } from 'react'

export const Textarea = forwardRef(function Textarea({ className, resizable = true, ...props }, ref) {
  return (
    <Headless.Textarea
      ref={ref}
      {...props}
      className={clsx(
        'block w-full rounded-lg border border-zinc-300 bg-white px-3 py-2 text-sm/6 text-zinc-950 shadow-sm transition placeholder:text-zinc-400',
        'hover:border-zinc-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20',
        'disabled:cursor-not-allowed disabled:bg-zinc-50 disabled:text-zinc-500 disabled:shadow-none',
        resizable ? 'resize-y' : 'resize-none',
        className
      )}
    />
  )
})
